import styled from 'styled-components';
import { Colors } from '@/common/colors/colors';
import Icon from '@/common/components/Icon';

export const ActiveIcon = styled(Icon)`
	font-size: 26px;
	cursor: pointer;
	color: ${Colors.darkBlue};
`;
